import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { classNames } from "../../utils";

export default function Badge({ active }) {
  return <div className={classNames("Badge", { active })}>
    <BadgeActive />
  </div>;
}

export function BadgeActive() {
  const [controlBadCirle, setControlBadCirle] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      setControlBadCirle(prev => !prev);
    }, 1000);
    return () => {
      if (timer) clearInterval(timer);
    };
  }, []);


  return <span className={classNames("Badge__circle-active", { active: controlBadCirle })} />;
}

Badge.propTypes = {
  active: PropTypes.bool,
};
